import React, { useState } from 'react';
import { Modal, PulsarText } from '@pulsarml/ui.react.components';
import { I18n, Translate } from '@utils/i18n';
import styles from './index.module.scss';
import { MetricWithNamedType } from '../../MachineMetricsComponent';
import { MultiSelect } from '@pulsarml/avalon-ui';

interface AddMetricModalProps {
  onClose: () => void;
  onConfirm: (metric: MetricWithNamedType[]) => void;
  metricsCatalogue: MetricWithNamedType[];
}

export function AddMetricModal({
  onConfirm,
  onClose,
  metricsCatalogue
}: AddMetricModalProps) {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const metricNameReformatList = ['annotation', 'total', 'correct', 'defects'];
  const _onConfirm = () => {
    const metricByNames: any = selectedOptions
      .map((option) => {
        return metricsCatalogue.find((metric) => metric.metric === option);
      })
      .filter((x) => x !== undefined);
    onConfirm(
      metricByNames.map((metric) => ({
        ...metric,
        metric: metric.metric,
        enabled: true
      }))
    );
  };

  return (
    <Modal
      form
      show
      modalCancelAction={{
        action: onClose,
        title: I18n.t('cancel')
      }}
      modalConfirmAction={{
        action: _onConfirm,
        title: I18n.t('confirm'),
        type: 'primary'
      }}
      showCloseIcon
      title={I18n.t('add_metric_in_machine_view')}
    >
      <div className={styles.root}>
        <div className="tw-mt-3">
          <PulsarText
            className={styles.fieldLabel}
            colorName="main"
            variant="t2"
            weight="regular"
          >
            <Translate value="metric_type" />
          </PulsarText>
          <MultiSelect
            selectButtonClassName="tw-w-full !tw-py-1 !tw-min-h-[48px] !tw-mt-0"
            selectContentClassName="tw-min-w-full"
            placeholder={I18n.t('add_metrics_catalogue')}
            values={selectedOptions}
            onChange={(options) => {
              setSelectedOptions(options);
            }}
            showSelectAll={metricsCatalogue.length > 0}
            showDiscreteBadgesForSelectAll={metricsCatalogue.length === 0}
            noOptionText={I18n.t('no_metric_found')}
            selectAllText={I18n.t('select_all')}
            options={metricsCatalogue
              .map((metric) => metric.metric)
              .map((metric) => ({
                label: metricNameReformatList.includes(metric)
                  ? I18n.t(`${metric}_metric`)
                  : I18n.t(metric),
                value: metric
              }))}
          />
        </div>
      </div>
    </Modal>
  );
}
